import { createAsyncThunk } from '@reduxjs/toolkit'
import { transformGroupUsersData } from 'common/utils/data-transformator'
import axios from 'api/apiCommon'
import { type UserGroupDetails, type GroupUser, type PaginatedResponse } from 'common/utils/types'

export const getMyStakeholderGroup = createAsyncThunk(
  '/stakeholder/getMyStakeholderGroup',
  async (): Promise<UserGroupDetails> => {
    return await new Promise((resolve, reject) => {
      axios
        .get<UserGroupDetails>(`${process.env.REACT_APP_USERS_API_URL ?? ''}/users/groups/my-group`)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => {
          console.error(err)
          reject(err)
        })
    })
  },
)

export const getStakeholderGroup = createAsyncThunk(
  '/stakeholder/StakeholderGroup',
  async (payload: { id: string }): Promise<UserGroupDetails> => {
    return await new Promise((resolve, reject) => {
      axios
        .get<UserGroupDetails>(`${process.env.REACT_APP_USERS_API_URL ?? ''}/users/groups/${payload.id}`)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => {
          console.error(err)
          reject(err)
        })
    })
  },
)

interface groupUsersParams {
  page?: number
  ipp?: number
}
export const getMyGroupUsers = createAsyncThunk(
  '/stakeholder/getMyGroupUsers',
  async (payload: {
    page?: number
    ipp?: number
    id: string
  }): Promise<{ groupUsers: GroupUser[]; count: number }> => {
    const params: groupUsersParams = {}
    if (payload?.page) {
      params.page = payload?.page
    } else {
      params.page = 0
    }
    if (payload?.ipp) {
      params.ipp = payload?.ipp
    }

    return await new Promise((resolve, reject) => {
      axios
        .get<PaginatedResponse<GroupUser[]>>(
          `${process.env.REACT_APP_USERS_API_URL ?? ''}/users/groups/my-group/group-users`,
          { params },
        )
        .then((data) => {
          resolve(transformGroupUsersData(data.data, data.count))
        })
        .catch((err) => {
          console.error(err)
          reject(err)
        })
    })
  },
)

export const getGroupUsers = createAsyncThunk(
  '/stakeholder/getGroupUsers',
  async (payload: {
    page?: number
    ipp?: number
    id: string
  }): Promise<{ groupUsers: GroupUser[]; count: number }> => {
    const params: groupUsersParams = {}
    if (payload?.page) {
      params.page = payload?.page
    } else {
      params.page = 0
    }
    if (payload?.ipp) {
      params.ipp = payload?.ipp
    }

    return await new Promise((resolve, reject) => {
      axios
        .get<{ data: GroupUser[]; count: number }>(`users/groups/${payload.id}/group-users`, { params })
        .then((data) => {
          resolve(transformGroupUsersData(data.data, data.count))
        })
        .catch((err) => {
          console.error(err)
          reject(err)
        })
    })
  },
)
